export const sizes = {
	desktop: 1440,
	tabletLandscape: 1024,
	tabletPortrait: 768,
	mobile: 375,
};
